import React, {PropTypes, Component} from 'react'
import {fromJS} from 'immutable'
import Edit from 'react-icons/lib/md/mode-edit'
//import Offering from 'react-icons/lib/md/blur-circular'
import cn from 'classnames'
import acc from 'accounting'

class ListSubjectsTableItem extends Component {
  _onSelectItem = () => {
    const {subject} = this.props
    const prereq = []
    const coreq = []

    // transform requisites to [1,2]
    if (subject.get('prereq')) {
      subject.get('prereq').map(req => prereq.push(req.get('id')))
    }

    if (subject.get('coreq')) {
      subject.get('coreq').map(req => coreq.push(req.get('id')))
    }

    let item = subject.set('prereq', fromJS(prereq))
    item = item.set('coreq', fromJS(coreq))
    this.props.onSelectItem(item)
  }

  _renderRequisites(subject) {
    let pre = subject.get('prereq').map(s => s.get('code')).toJS()
    let co = subject.get('coreq').map(s => s.get('code')).toJS()
    let st = ''
    if (subject.get('standing') !== '0') {
      st = ' ; ST:' + subject.get('standing')
    }

    pre = pre.join(', ')
    co = co.join(', ')
    co = co ? ' / ' + co : co
    return <div><small>{pre}{co}{st}</small></div>
  }

  render() {
    const {subject} = this.props
    const inGPA = subject.get('is_in_gpa')

    const lecUnits = acc.formatNumber(subject.get('lec_units'), 1)
    const labUnits = acc.formatNumber(subject.get('lab_units'), 1)
    const units = acc.formatNumber(subject.get('units'), 1)

    const lec = inGPA ? lecUnits : `(${lecUnits})`
    const lab = inGPA ? labUnits : `(${labUnits})`
    const unit = inGPA ? units : `(${units})`
    const cl = cn({danger: subject.get('loose')})

    return (
      <tr className={cl}>
        <td>
          <button
            type="button"
            onClick={this._onSelectItem}
            className="btn-icon btn-inline"
          >
            <Edit />
          </button>
          {/*<button type="button" className="btn-icon btn-inline"><Offering /></button>*/}
        </td>
        <td><code>{subject.get('code')}</code></td>
        <td>{subject.get('name')}</td>
        <td className="text-right">{lec}</td>
        <td className="text-right">{lab}</td>
        <td className="text-right"><strong>{unit}</strong></td>
        <td>{this._renderRequisites(subject)}</td>
      </tr>
    )
  }
}

ListSubjectsTableItem.propTypes = {
  subject: PropTypes.object,
  onSelectItem: PropTypes.func,
}

export default ListSubjectsTableItem



// WEBPACK FOOTER //
// ./src/containers/Manage/Curriculums/list-subjects-table-item.js